//DrawerMenu.tsx ==============================================================
import "../Util/Prototypes";

import * as AgriculturalUse from "../Widgets/AgriculturalUse";
import * as CommunityInfo from "../Widgets/CommunityInfo";
import * as CompareMaps from "../Widgets/CompareMaps";
import * as CrimeSearch from "../Crime Search/CrimeSearch";
import * as Custom from "../Custom";
import * as Default from "../Default";
import * as DrawerMenu from "./DrawerMenu";
import * as ElevationProfile from "../Widgets/ElevationProfile";
import * as IdentifyPopup from "../Widgets/IdentifyPopup";
import * as MainMap from "../MainMap";
import * as MainToolbar from "./MainToolbar";
import * as Measure from "../Widgets/Measure";
import * as PrevTool from "./PrevTool";
import * as PrintMap from "../Print/PrintMap";
import * as QueryString from "../QueryString";
import * as QuickSearch from "../Search/QuickSearch";
import * as SalesSearch from "../Sales Search/SalesSearch";
import * as SalesSearchSettings from "../Sales Search/SalesSearchSettings";
import * as Search from "../Search/Search";
import * as SelectOnMap from "../Search/SelectOnMap";
import * as Settings from "../Settings";
import * as ShareMap from "../Widgets/ShareMap";
import * as SignIn_Auth0 from "../Util/SignIn_Auth0";
import * as Sketch from "../Widgets/Sketch";
import * as Spinner from "../Util/Spinner";
import * as Util from "../Util/Util";
import * as Widgets from "../Widgets/Widgets";

import { Avatar, Divider, Drawer, Icon, List, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import * as React from "react"; //For legacy React components.

//ESRI javascript API.
export let curToolName: string = "";
export let prevToolName: string = "";
export let prevToolNext: string = "";
export let classRef: DrawerMenu.Build;

//Setters.
export function setPrevToolName(toolName: string) {
   prevToolName = toolName;
}
export function setPrevToolNext(toolName: string) {
   prevToolNext = toolName;
}

//Process window resize event.
window.addEventListener('resize', function () {
   if (MainToolbar && Default.theme) {
      MainToolbar.render();
   }
   if (Widgets && MainMap.activeView) {
      //Util.errMsg("Screen, Inner, Outer: " + window.screen.width + " " + window.innerWidth + " " + window.outerWidth);
      Widgets.setPosition(); //Update widget positions on window resize.
   }
}, { passive: true });

//Init tool. Force an active tool and clear previous tool.
export function initTool(toolName: string): void {
   //Util.errMsg("DrawerMenu.initTool: " + toolName + " " + Search.activeSearchTool + " " + DrawerMenu.curToolName);
   prevToolName = toolName;
   PrevTool.classRef.refresh(toolName);
}

//Show a widget tool.
export function showTool(toolName: string): void {
   //Util.errMsg("DrawerMenu.showToolFunc: " + toolName + " " + Search.activeSearchTool + " " + DrawerMenu.curToolName);
   MainMap.activeViewDiv.style.cursor = "default";

   //Dialog tools.
   if (toolName === "Share Map") {
      ShareMap.show();
      return;
   }

   //Misc custom tools. Custom!
   if (toolName === "Open Data Hub" || toolName === "Feedback" || toolName === "Contact Us" || toolName === "Home" || toolName === "Privacy Policy") {
      Custom.openLink(toolName);
      return;
   }

   //Tools that don't have a menu or dialog.
   if (toolName === "Dim_2D_3D" || toolName === "Elevation Profile" || toolName === "Sign_In_Out" || toolName === "Toggle_MapTips" || toolName === "Toggle_XY") {

      //Clear interactive tools.
      AgriculturalUse.clearTool();
      CommunityInfo.clearTool();
      CompareMaps.clearTool();
      CrimeSearch.clearTool();
      IdentifyPopup.clearTool();
      Measure.clearTool();
      PrintMap.clearTool();
      QuickSearch.clearTool();
      SalesSearch.clearTool();
      SelectOnMap.clearTool();
      Sketch.clearTool();

      classRef.hide();

      if (toolName === "Dim_2D_3D") {
         MainMap.toggle_2D_3D();

      } else if (toolName === "Elevation Profile") {
         ElevationProfile.show();

      } else if (toolName === "Toggle_MapTips") {
         Settings.setShowMapTips(!Settings.showMapTips);
         localStorage.SetItem("ShowMapTips", Settings.showMapTips);

      } else if (toolName === "Toggle_XY") {
         Settings.setShowCoordinates(!Settings.showCoordinates);
         Widgets.disableCoordWidgetCaptureMode();
         Widgets.setPosition();
         localStorage.SetItem("ShowCoordinates", Settings.showCoordinates);

      } else if (toolName === "Sign_In_Out") {
         if (SignIn_Auth0.signedIn) {
            SignIn_Auth0.signOut();
         } else {
            SignIn_Auth0.signIn();
         }
      }
      return;
   }

   //Tools with a left panel menu.
   if (DrawerMenu.curToolName) {
      if (toolName === DrawerMenu.prevToolNext) {
         classRef.hide();

         if (DrawerMenu.prevToolName === "Search Results" && Search.grandTotRec === 0) {
            //DrawerMenu.prevToolNext = "";
            PrevTool.classRef.refresh("");

         } else if (DrawerMenu.prevToolName === "Sales Results" && SalesSearch.layer.totRec === 0) {
            PrevTool.classRef.refresh("");

         } else if (DrawerMenu.prevToolName === "Crime Results" && CrimeSearch.layer.totRec === 0) {
            PrevTool.classRef.refresh("");
         }

         return;
      }

      //Disable tools that require results records.
      if (DrawerMenu.prevToolNext === "Search Results" && Search.grandTotRec === 0) {
         prevToolNext = "";

      } else if (DrawerMenu.prevToolNext === "Sales Results" && SalesSearch.layer.totRec === 0) {
         prevToolNext = "";

      } else if (DrawerMenu.prevToolNext === "Crime Results" && CrimeSearch.layer.totRec === 0) {
         prevToolNext = "";
      }

      prevToolName = DrawerMenu.prevToolNext;
      PrevTool.classRef.refresh(DrawerMenu.prevToolName);

   } else {
      if (toolName === DrawerMenu.prevToolName) {
         prevToolClick();
         return;
      }
   }
   prevToolNext = toolName;
   classRef.showTool(toolName);
}

//Close current widget tool and toggle previous tool button.
export function closeTool(): void {
   //Util.errMsg("DrawerMenu.closeTool: " + Search.activeSearchTool + " " + DrawerMenu.curToolName);

   if (DrawerMenu.curToolName) {

      //Disable tools that require results records.
      if (DrawerMenu.prevToolNext === "Search Results" && Search.grandTotRec === 0) {
         prevToolNext = DrawerMenu.prevToolName;

      } else if (DrawerMenu.prevToolNext === "Sales Results" && SalesSearch.layer.totRec === 0) {
         prevToolNext = DrawerMenu.prevToolName;

      } else if (DrawerMenu.prevToolNext === "Crime Results" && CrimeSearch.layer.totRec === 0) {
         prevToolNext = DrawerMenu.prevToolName;
      }

      //Update hover sublayers.
      //Highlight.updateParameters();

      //Clear interactive tools.
      AgriculturalUse.clearTool();
      CommunityInfo.clearTool();
      CompareMaps.clearTool();
      CrimeSearch.clearTool();
      IdentifyPopup.clearTool();
      Measure.clearTool();
      PrintMap.clearTool();
      QuickSearch.clearTool();
      SalesSearch.clearTool();
      SelectOnMap.clearTool();
      Sketch.clearTool();

      const toolName: string = DrawerMenu.prevToolNext;
      prevToolNext = DrawerMenu.prevToolName;
      prevToolName = toolName;
      PrevTool.classRef.refresh(DrawerMenu.prevToolName);
      classRef.hideTool();
   }
}

//Previous tool click event.
export function prevToolClick(toolValue?: string): void {
   if (Spinner.busy) {
      return;
   }

   if (toolValue === "Elevation Profile") {
      ElevationProfile.show();
      MainMap.activeViewDiv.style.cursor = "default";
      return;
   }

   MainMap.activeViewDiv.style.cursor = "default";

   if (DrawerMenu.prevToolName === "" && toolValue) {
      prevToolName = toolValue;
   }
   const toolName: string = DrawerMenu.prevToolName;

   //Disable tools that require results records.
   if (DrawerMenu.prevToolNext === "Search Results" && Search.grandTotRec === 0) {
      prevToolNext = "";

   } else if (DrawerMenu.prevToolNext === "Sales Results" && SalesSearch.layer.totRec === 0) {
      prevToolNext = "";

   } else if (DrawerMenu.prevToolNext === "Crime Results" && CrimeSearch.layer.totRec === 0) {
      prevToolNext = "";
   }

   prevToolName = DrawerMenu.prevToolNext;
   prevToolNext = toolName;

   PrevTool.classRef.refresh(DrawerMenu.prevToolName);
   classRef.showTool(toolName);
}

//Check if valid tool for 2D or 3D mode.
export function isValidTool3D(toolName: string): boolean {
   let validTool: boolean = true;
   if (!MainMap.view2D) {
      if (toolName === "Bookmarks" || toolName === "Compare Maps" || toolName === "Crime Search") {
         validTool = false; //Not valid in 3D mode.
      }
   }
   return validTool;
}

interface iProps {
}
interface iState {
   open: boolean;
}

export class Build extends React.Component<iProps, iState> {
   constructor(props: iProps) {
      super(props);
      this.state = { open: false };
   }

   refresh(): void {
      this.setState(this.state);
   }

   show(): void {
      this.setState({ open: true });
   }

   hide(): void {
      this.setState({ open: false });
   }

   showTool(toolName: string): void {
      //Util.errMsg("DrawerMenu.showToolClass: " + toolName + " " + Search.activeSearchTool + " " + DrawerMenu.curToolName);

      //Clear interactive tools.
      if (toolName !== "Agricultural Use") {
         AgriculturalUse.clearTool();
      }
      if (toolName !== "Community Information") {
         CommunityInfo.clearTool();
      }
      if (toolName !== "Compare Maps") {
         CompareMaps.clearTool();
      }
      if (toolName !== "Crime Search") {
         CrimeSearch.clearTool();
      }
      if (toolName !== "Measure") {
         Measure.clearTool();
      }
      if (toolName !== "PrintMap") {
         PrintMap.clearTool();
      }
      if (toolName !== "Quick Search") {
         QuickSearch.clearTool();
      }
      if (toolName !== "Sales Search") {
         SalesSearch.clearTool();
      }
      if (toolName !== "Select on Map" && toolName !== "Search Results") {
         SelectOnMap.clearTool();
      }
      if (toolName !== "Sketch") {
         Sketch.clearTool();
      }

      this.hide();
      this.hideTool();
      curToolName = toolName;
      Widgets.show(toolName);

      //Don't store tools that require results records.
      if (toolName !== "Search Results" && toolName !== "Sales Results" && toolName !== "Crime Results") {
         localStorage.SetItem("prevToolText", toolName);
      }
   }

   //Hide the currently open tool.
   hideTool(): void {
      if (DrawerMenu.curToolName) {
         curToolName = "";
         Widgets.show("");
      }
   }

   //Get list item.
   getListItem(toolName: string): JSX.Element[] {
      const jsx: JSX.Element[] = [];

      if (!toolName.startsWith(" ")) {
         const ti: Settings.iToolInfo = Settings.getToolInfo(toolName);

         if (toolName === "Community Information" || toolName === "Select on Map") {
            ti.label = toolName;
         }

         jsx.push(
            <ListItemButton key={Util.uid()} dense={!Settings.isPhone} disableGutters={true} onClick={DrawerMenu.showTool.bind(this, toolName)} title={ti.tip}>
               &nbsp;&nbsp;&nbsp;
               <ListItemIcon><Icon style={{ color: ti.iconColor }}>{ti.iconName}</Icon></ListItemIcon>
               <ListItemText primary={ti.label} />
            </ListItemButton>,
         );
      }
      return jsx;
   }

   render() {
      Util.logMsg('Refreshing DrawerMenu.tsx components.');

      //Hide tools that only work in either 2D or 3D.
      let bookmarks_visible: boolean = false;
      if (MainMap.view2D) {
         bookmarks_visible = true;
      }

      let compareMaps_visible: boolean = false;
      if (MainMap.view2D) {
         compareMaps_visible = true;
      }

      let crimeResults_visible: boolean = false;
      if (CrimeSearch.layer.totRec > 0) {
         crimeResults_visible = true;
      }

      let searchResults_visible: boolean = false;
      if (Search.grandTotRec > 0) {
         searchResults_visible = true;
      }

      let salesResults_visible: boolean = false;
      if (SalesSearch.layer.totRec > 0) {
         salesResults_visible = true;
      }

      let exportMapLayers_visible: boolean = false;
      if (Settings.security.accessLevel >= Settings.security.accessLevel_exportMapLayers) {
         exportMapLayers_visible = true;
      }

      let mapTips_visible: boolean = false;
      if (Settings.mapTipLayers.length > 0) {
         mapTips_visible = true;
      }

      //Add a leading blank space to comment out tools. Custom!
      return (
         <Drawer id="main-drawer" open={this.state.open} onClose={this.hide.bind(this)} variant="temporary">
            <div style={{ width: Settings.leftPanelWidth }}
               tabIndex={0}
               role="button"
               onClick={this.hide.bind(this)}
               onKeyDown={this.hide.bind(this)}
            >
               <List component="nav" aria-label="Main Menu" disablePadding={true}>
                  <ListItemButton disableGutters={true} style={{ backgroundColor: Settings.headingColor }}>
                     &nbsp;&nbsp;&nbsp;
                     <ListItemAvatar><Avatar variant="rounded" src="Images/apple-touch-icon.png" alt="Logo" /></ListItemAvatar>
                     <ListItemText primary={Settings.websiteTitle} />
                     <ListItemIcon><Icon>navigate_before</Icon></ListItemIcon>
                  </ListItemButton>
               </List>

               <Divider />

               <List component="nav" aria-label="Search types" disablePadding={true}>
                  {this.getListItem("Quick Search")}
                  {this.getListItem("Advanced Search")}
                  {this.getListItem("Select on Map")}
                  {searchResults_visible && this.getListItem("Search Results")}
               </List>

               <Divider />

               <List component="nav" aria-label="Map information" disablePadding={true}>
                  {this.getListItem("Map Layers")}
                  {this.getListItem("Basemap Gallery")}
                  {this.getListItem("Map Themes")}
                  {bookmarks_visible && this.getListItem("Bookmarks")}
                  {this.getListItem("Legend")}
               </List>

               <Divider />

               <List component="nav" aria-label="Map tools" disablePadding={true}>
                  {this.getListItem("Community Information")}

                  {Settings.security.accessLevel >= SalesSearchSettings.ss.accessLevel && <div>
                     {this.getListItem("Sales Search")}
                     {salesResults_visible && this.getListItem("Sales Results")}
                  </div>}

                  {MainMap.view2D && this.getListItem("Crime Search")}
                  {MainMap.view2D && crimeResults_visible && this.getListItem("Crime Results")}

                  {this.getListItem("Sketch")}
                  {this.getListItem("Measure")}
                  {this.getListItem("Print")}
                  {!Settings.isPhone && exportMapLayers_visible && this.getListItem("Open Data Hub")}
                  {this.getListItem("Web Maps")}
                  {this.getListItem("Elevation Profile")}
                  {compareMaps_visible && this.getListItem(" Compare Maps")}
               </List>

               <Divider />

               <List component="nav" aria-label="More tools" disablePadding={true}>
                  {this.getListItem("Share Map")}
                  {this.getListItem("Toggle_XY")}
                  {Settings.enabled3D && this.getListItem("Dim_2D_3D")}
                  {mapTips_visible && this.getListItem("Toggle_MapTips")}
                  {Settings.signInEnabled && this.getListItem("Sign_In_Out")}
                  {this.getListItem("Contact Us")}
                  {this.getListItem("Feedback")}
               </List>
            </div>
         </Drawer>
      );
   } //end render.

   //Component mounted.
   componentDidMount() {
      classRef = this as DrawerMenu.Build; //Save reference to this component.

      if (QueryString.pin || QueryString.address) {
         QueryString.setStartupTool("Quick Search");
      }

      const prevToolText: string = localStorage.GetItem("prevToolText") as string;
      const width: number = Util.windowWidth();

      if (QueryString.startupTool) {
         setTimeout(function () { DrawerMenu.showTool(QueryString.startupTool); }, 300); //Wait for map view to load.

      } else if (Settings.startupTool) {
         setTimeout(function () { DrawerMenu.showTool(Settings.startupTool); }, 300); //Wait for map view to load.

         //Phones.
      } else if (width < Settings.smallScreenWidth) {
         DrawerMenu.initTool("Quick Search");

         //Initialize previous tool name.
      } else if (prevToolText) {
         const ok: boolean = isValidTool3D(prevToolText); //Don't show tools that only work in 2D.
         if (ok) {
            DrawerMenu.initTool(prevToolText);
         }
      }
   }

   //componentDidUpdate() {
   //   if (MainMap && MainMap.mapView) {
   //      MainMap.mapView.on("pointer-move", function (event) {
   //         classRef.hide();
   //      });
   //   }
   //}

} //end build class.
